export const TRANSITION_TIME = 300;

export function transitionComplete(cb, time = TRANSITION_TIME) {
  setTimeout(() => cb(), time);
}

export const nextFrameAsync = () =>
  new Promise((resolve) => window.requestAnimationFrame(() => resolve()));

export const wait = (amount = 0) =>
  new Promise((resolve) => setTimeout(resolve, amount));
